// extracted by css-extract-rspack-plugin
export default {"OmnibarDrawerContainer":"omnibar-drawer-module__OmnibarDrawerContainer__GA_dm9u"};